module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "ql-editor",
    domProps: {
      "innerHTML": _vm._s(_vm.intro)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-155e9eb6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/views/activity/components/preview.vue
// module id = 888
// module chunks = 0